
import { defineComponent, PropType } from 'vue';
import { Block } from '@/models/Blocks/block';
import { findClassBorderColor } from '@/scss/StyleClassManager';
import { BlockFactory } from '@/models/Blocks/Itens/block-factory';
import { BackEndContent } from '@/models/Blocks/backend-content';
import { TemplateStruct } from "@/models/Blocks/Itens/Types/template-struct";
import { HistoryPosition } from '@/models/Blocks/history-position';
import { Banner } from '@/models/Blocks/banner';
import baseUrl from "@/api/base-url";
import request from '@/Utilities/httpRequest';
import weblogBlocks from '../../../../../../../src-js/monitor-user-behaviour-2/weblog-blocks.js';

export default defineComponent({
    components: {
    },
    props:{
        blocks:{
            type: Array<Object>,
            default: () => []
        },
        colors:{
            type: Array<Object>,
            default: () => []
        },
        bannerPriority:{
            type: Array as PropType<Banner>,
            default: () => []
        },
        contentUrl:{
            type: String,
            default: baseUrl.getUrl('site/block')
        },
        border: {
            type: Boolean,
            default: false
        },
        context: {
            type: String,
            default: undefined
        },
        useObserver:{
            type: Boolean,
            default: true
        }
    },
    data(){
        let timerToCall: any|undefined = undefined;
        let timerToCallBlocks: any|undefined = undefined;
        let borderColor: string|null = null;
        let banners: Array<{id: string, params: string, specs: string }> = [];
        let lastPromo: object|null = null;
        return {
            elements: new Map<string, Block>(),
            oldElements: new Map<string, Block>(),
            list: new Array<Block>(),
            loadBlocks: new Map<string, Block>(),
            colorIndex: 0,
            groupColor: new Array<any>(),
            timerToCall,
            timerToCallBlocks,
            borderColor,
            colorsStruct: new Array<any>(),
            banners,
            lastPromo,
            loading: false,
            showSocialModal: false,
            urlSocialModal: '',
            visualViewportWidth: Math.max(document.documentElement.clientWidth || 100, window.innerWidth || 100),
            webLogProc: this.context,
        }
    },
    destroyed() {
        window.addEventListener("resize",this.calcVisualViewportWidth);
    },
    mounted(){
        if ('scrollRestoration' in history) {
            // Back off, browser, I got this...
            history.scrollRestoration = 'manual';
        }
        this.calcVisualViewportWidth();
        if(this.blocks.length === 0){
            window.addEventListener("resize",this.calcVisualViewportWidth);
            this.siteBlocks(this.gridSelected);
        }else{
            this.colorsStruct = this.colors;
            this.setData(this.blocks);
        }
        this.calcShowSocialModal();
    },
    watch:{
        gridSelected(newGrid: number){
            clearTimeout(this.timerToCallBlocks);
            this.loading = true;
            this.timerToCallBlocks = setTimeout(() => { this.siteBlocks(newGrid);}, 1000);
        }
    },
    computed:{
        gridSelected(): number{
            // use 1910 as reference for Full HD (ex: Edge reports 1912px)
            return this.visualViewportWidth < 900 ? 6 : (this.visualViewportWidth >= 1910 ? 16 : 12);
        },
        margin(){
            return this.visualViewportWidth * 2;
        }
    },
    methods:{

        /**
         * Calc the show modal 
         */
        calcShowSocialModal(){
            if(HistoryPosition.isBack() || HistoryPosition.isReload()){
                let hash = window.location.hash;
                if(hash.includes('#mtm-')){
                    let mtm = hash.replace('#mtm-','');
                    if(mtm && mtm != hash){
                        try{
                            this.urlSocialModal = decodeURIComponent(atob(mtm));
                        }catch(e){
                            return false;
                        }
                        this.showSocialModal = true;
                    }
                }
            }
        },

        /**
         * Calc the visual viewport width
         */
        calcVisualViewportWidth(){
            this.visualViewportWidth =  Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        },

        /**
         * Load blocks struct 
         * @param grid 
         */
        siteBlocks(grid: number){
            clearTimeout(this.timerToCallBlocks);
            this.loadBlocks = new Map<string, Block>();
            //this.$el.closest('.prz-blk');

            let params: any = {grid: grid};
            if(this.context){
                params = {...params, context: this.context};
            }
            const event = new CustomEvent('gridChanged', {detail: params});
            this.$el.dispatchEvent(event);
            try{
                const searchParams = new URLSearchParams(window.location.search);
                if(searchParams.has('cache-update')){
                    params = {...params,['cache-update']: searchParams.get('cache-update')};
                }
            }catch(e){}

            request.get(baseUrl.getUrl('site/blocks'), params, false).then(r => {
                this.list     = [];
                this.oldElements = new Map(this.elements);
                this.elements = new Map<string, Block>();
                this.colorsStruct = r.data.colors ?? [];
                this.setData(r.data.blocks ?? []);
                this.loading = false;
            });
        },
        /**
         * Load block content, from back-end
         */
        async loadBlocksContents(){
            // Preparing the block parameters
            let paramsData = {};
            let blocks = new Map(this.loadBlocks);
            this.loadBlocks = new Map<string, Block>(); 
            blocks.forEach((b,id) => {
                paramsData = {...paramsData, ...{
                    [id]: {
                        id: b.id,
                        params: b.params,
                        specs: b.specs ?? btoa(JSON. stringify({})),
                        props: btoa(JSON. stringify(b.properties)),
                        order: b.order
                    }
                }};
            });

            //Make the call
            //const { data } = await request.post(this.contentUrl, {data: paramsData, version: 'v2'}, false);
            //const data = await this.backEndCall(paramsData,false);
            const data = await BackEndContent.get(this.contentUrl, paramsData, false);
            Object.keys(data).forEach((id) => {
                let block     = this.elements.get(`${id}`);
                if(block){
                    const blockData = data[id] ?? {};
                    const title     = blockData.title ?? null;
                    const oti       = blockData.oti ?? null;
                    const key       = blockData.key ?? '';
                    if(title){
                        // update title
                        block.title = title;
                    }
                    if(oti){
                        //console.log('update OTI', oti);
                        // update OTI
                        block.oti = oti;
                    }

                    block.saveOnSession = (blockData.elements??null ? true : false);
                    
                    this.setBlockContent(blockData.elements ?? [], block, key);
                }
            });
        },
        
        /**
         * Set the block content
         * @param data 
         * @param block 
         */
        setBlockContent(data: Array<object>|{[key: string]: object}, block: Block, keyContent: string){
            let content = data;

            //reset block colors groups
            this.groupColor = [];

            //reset border color
            this.borderColor = null;

            if(Array.isArray(data)){
                content = data.map(ele => this.setColor(ele));
            }else{
                let rst = {};
                for (const [key, value] of Object.entries(data)) {
                    rst = {...rst, ...{[key]: this.setColor(value)}};
                }

                // Add promo details to bundle object and add url to QA test
                Object.values(rst).forEach( (ele: any) => {
                    let type: any = Object.keys(ele)[0] ?? null;
                    if(type && type.toString() == 'bundle' && this.lastPromo){
                        if(ele[type] ?? null){
                            ele[type].promoReference = this.lastPromo;
                        }
                    }
                });

                content = rst;
            }
            block.loading = false;
            if(!block.template.id || block.template.id == keyContent){
                block.content = content;
            }else{
                if(!block.retayAttempt){
                    block.retayAttempt = true;
                    this.getBlockContent(block.id);
                }else{
                    block.saveOnSession = false;
                    block.content = [];
                }
            }
            if(this.border && this.borderColor){
                block.borderColor = this.borderColor;
            }
            weblogBlocks.add('WLBLK_RENDER', block.oti, this.webLogProc, block.order, this.gridSelected);
        },
        
        /**
         * Set color of the block item
         * @param data 
         */
        setColor(data: any){
            let dataObj: any = Object.values(data)[0] ?? null;
            let colorId = dataObj ? dataObj.colorId : null;
            let group   = dataObj ? dataObj.group : null;

            //if has color group, set color with that group, otherwise find by the color Id
            let color   = this.groupColor[group] ?? this.colorsStruct.find(c => c.id ==  colorId);

            //if color is not defined, get the next color in the array
            if(!color){
                colorId = null;
                color   = this.colorsStruct.length > 0 ? this.colorsStruct[(this.colorIndex % this.colorsStruct.length)] : null;
            }

            if(!color){
                return data;
            }

            let state: string = JSON.stringify(data);
            let type: any = Object.keys(data)[0] ?? null;
            let result: any = BlockFactory.applyColor(data, color);

            //save the last promo type (to set on bundle struct)
            if(type && type.toString() == 'promo'){
                this.lastPromo = result[type] ?? null;
            }

            //increment the color index
            if(JSON.stringify(result) != state){
                this.borderColor = color.border ?? this.borderColor;
                if(colorId == null){
                    this.colorIndex++;
                }
            }

            //Save the group, for next elements
            if(group && !(this.groupColor[group] ?? null)){
                this.groupColor[group] = color;
            }

            return result;
        },
        /**
         * Create a new object block 
         * @param data 
         */
        setData(data: Array<any>){
            data.forEach((o) => {
                //allow only one element of banners
                if(this.banners.length == 0 && (o.isBanner ?? null)){
                    const banner = {id: `${o.id}`, params: o.params, specs: o.specs}
                    this.banners.push(banner);
                }
                if((o.id ?? null) && (o.order ?? null) && (o.template ?? null) && !(o.isBanner ?? null)){
                    const b = new Block(o.id,o.order,o.title,o.template,(o.params ?? undefined),(o.content ?? null ? false:true));
                    if(this.useObserver){
                        b.isVisible = false;
                    }
                    if(o.oti ?? null){
                        b.oti = o.oti;
                    }
                    if(o.ttl ?? null){
                        b.ttl = o.ttl;
                    }
                    if(o.label ?? null){
                        b.label = o.label;
                    }
                    if(o.titleAlign ?? null){
                        b.titleAlign = o.titleAlign;
                    }
                    /*if(o.params ?? null){
                        b.params = o.params;
                    }*/
                    if(o.specs ?? null){
                        b.specs = o.specs;
                    }
                    if(o.pointsInfo){
                        b.pointsInfo = o.pointsInfo;
                    }
                    if(o.content ?? null){
                        this.setBlockContent(o.content, b, o.template?.id??'-');
                    }
                    const old = this.oldElements.get(`${o.id}`);
                    if(old){
                        b.isVisible  = old.isVisible
                    }
                    const required = (o.isRequired ?? null) || (old?.isVisible ?? false);
                    this.elements.set(`${o.id}`,b);

                    // trigger event "load" before set content
                    this.webLogProc = o.wlproc ?? this.webLogProc;
                    weblogBlocks.add('WLBLK_LOAD', b.oti, this.webLogProc, b.order, this.gridSelected);

                    if(required){
                        this.getBlockContent(`${o.id}`);
                    }
                }
            });
            this.list = Array.from(this.elements.values());
        },
        /**
         * Trigger event, when the element is visible on the screen
         * @param isVisible 
         * @param entry 
         */
        visibilityChanged(isVisible: boolean, entry: any) {
            let id = entry.target.id ?? null;
            if(isVisible && id) {
                this.getBlockContent(`${id}`);
                let block = this.elements.get(`${id}`);
                if(block){
                    block.isVisible = true;
                }
            }
        },
        /**
         * Add block to get content queue
         * @param id 
         */
        getBlockContent(id: string) {
            let block = this.elements.get(`${id}`);
            if(block && !block.hasContent() && !block.loading) {
                clearTimeout(this.timerToCall);
                this.loadBlocks.set(`${id}`, block);
                block.loading = true;
                this.timerToCall = setTimeout(() => {
                    this.loadBlocksContents();
                }, 400);
            }
            else if(block){
                weblogBlocks.add('WLBLK_RENDER', block.oti, this.webLogProc, block.order, this.gridSelected);
            }
        },
        /**
         * Return the TemplateStruct object
         * @param value 
         */
        getItemStruct(value: Object): TemplateStruct|undefined{
            return value instanceof TemplateStruct ? value : undefined;
        },

        getItemBorderClass(item: Object): string|undefined{
            if(this.border && (item instanceof Block)){
                return item.borderColor ? findClassBorderColor(item.borderColor) ?? undefined : undefined;
            }
            return undefined;
        }
    }
});
